"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tapis Files API
 * My API
 *
 * The version of the OpenAPI document: 0.0
 * Contact: cicsupport@tacc.utexas.edu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var runtime_1 = require("../runtime");
/**
* @export
* @enum {string}
*/
var TransferTaskChildStatusEnum;
(function (TransferTaskChildStatusEnum) {
    TransferTaskChildStatusEnum["Accepted"] = "ACCEPTED";
    TransferTaskChildStatusEnum["Staging"] = "STAGING";
    TransferTaskChildStatusEnum["Staged"] = "STAGED";
    TransferTaskChildStatusEnum["InProgress"] = "IN_PROGRESS";
    TransferTaskChildStatusEnum["Completed"] = "COMPLETED";
    TransferTaskChildStatusEnum["Cancelled"] = "CANCELLED";
    TransferTaskChildStatusEnum["Failed"] = "FAILED";
    TransferTaskChildStatusEnum["Paused"] = "PAUSED";
})(TransferTaskChildStatusEnum = exports.TransferTaskChildStatusEnum || (exports.TransferTaskChildStatusEnum = {}));
function TransferTaskChildFromJSON(json) {
    return TransferTaskChildFromJSONTyped(json, false);
}
exports.TransferTaskChildFromJSON = TransferTaskChildFromJSON;
function TransferTaskChildFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !runtime_1.exists(json, 'id') ? undefined : json['id'],
        'tenantId': !runtime_1.exists(json, 'tenantId') ? undefined : json['tenantId'],
        'username': !runtime_1.exists(json, 'username') ? undefined : json['username'],
        'sourceURI': !runtime_1.exists(json, 'sourceURI') ? undefined : json['sourceURI'],
        'destinationURI': !runtime_1.exists(json, 'destinationURI') ? undefined : json['destinationURI'],
        'totalBytes': !runtime_1.exists(json, 'totalBytes') ? undefined : json['totalBytes'],
        'bytesTransferred': !runtime_1.exists(json, 'bytesTransferred') ? undefined : json['bytesTransferred'],
        'taskId': !runtime_1.exists(json, 'taskId') ? undefined : json['taskId'],
        'errorMessage': !runtime_1.exists(json, 'errorMessage') ? undefined : json['errorMessage'],
        'parentTaskId': !runtime_1.exists(json, 'parentTaskId') ? undefined : json['parentTaskId'],
        'retries': !runtime_1.exists(json, 'retries') ? undefined : json['retries'],
        'dir': !runtime_1.exists(json, 'dir') ? undefined : json['dir'],
        'uuid': !runtime_1.exists(json, 'uuid') ? undefined : json['uuid'],
        'status': !runtime_1.exists(json, 'status') ? undefined : json['status'],
        'created': !runtime_1.exists(json, 'created') ? undefined : (new Date(json['created'])),
        'startTime': !runtime_1.exists(json, 'startTime') ? undefined : (new Date(json['startTime'])),
        'endTime': !runtime_1.exists(json, 'endTime') ? undefined : (new Date(json['endTime'])),
    };
}
exports.TransferTaskChildFromJSONTyped = TransferTaskChildFromJSONTyped;
function TransferTaskChildToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'tenantId': value.tenantId,
        'username': value.username,
        'sourceURI': value.sourceURI,
        'destinationURI': value.destinationURI,
        'totalBytes': value.totalBytes,
        'bytesTransferred': value.bytesTransferred,
        'taskId': value.taskId,
        'errorMessage': value.errorMessage,
        'parentTaskId': value.parentTaskId,
        'retries': value.retries,
        'dir': value.dir,
        'uuid': value.uuid,
        'status': value.status,
        'created': value.created === undefined ? undefined : (value.created.toISOString()),
        'startTime': value.startTime === undefined ? undefined : (value.startTime.toISOString()),
        'endTime': value.endTime === undefined ? undefined : (value.endTime.toISOString()),
    };
}
exports.TransferTaskChildToJSON = TransferTaskChildToJSON;
